<div (window:resize)="onResize($event, null)">
  <div class="container-fluid" [ngStyle]="{'left': left}">
    <div class="widgetScrollBar" style="transform: translateZ(0)">
      <div class="widget-left" [ngStyle]="{ 'opacity': rightArrow }" (click)="goLeft()">
        <img class="arrow-icon" alt="left arrow" src="../../../assets/widget-bar/left-icon.png" />
      </div>
      <div class="widgetBar" [ngStyle]="{'max-width': toolBarWidth, 'width': actualWidth }" >
        <div class="widget" *ngFor="let widget of config.tools; let i=index" id="widget_{{i}}"
             [ngStyle]="{ 'visibility': widget.visible, 'width':widget.width, 'padding-left': widget.padding, 'padding-right': widget.padding,
                                'margin-left': widget.margin, 'margin-right': widget.margin }"
             (click)="widgetClick(i)" [ngClass]="[widget.status, widget.button, widget.id]" [matTooltip]="widget.name">
          <img class="widget-icon" [alt]="widget.name" [ngStyle]="{'width': widget.iconWidth }" [src]="widget.icon" />
        </div>
      </div>
      <div class="widget-right" [ngStyle]="{ 'opacity': leftArrow }" (click)="goRight()">
        <img class="arrow-icon" alt="right arrow" src="../../../assets/widget-bar/right-icon.png" />
      </div>
    </div>
  </div>
</div>
